<template>
	<div class="pages-notice">
		<van-nav-bar class="custom-nav-bar" :title="$t('notice.page_title')">
			<template #left>
				<div style="width: 86px; height: 32px; margin-left: 15px;" @click="back()">
					<div class="nav-bar__back">
						<span class="tn-icon-left-arrow"></span>
					</div>
				</div>
			</template>
		</van-nav-bar>
		<div class="page-content">
			<div class="notice-list">
				<div class="empty-state">
					<div class="empty-icon">
						<span class="tn-icon-bell tn-text-5xl tn-color-gray"></span>
					</div>
					<div class="empty-text">
						{{ $t('common.no_records') }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isLoading: false,
				notice: {},
				loading: false,
				finished: false,
			};
		},
		methods: {
			back() {
				return window.history.back();
			},
			getNoticeList() {
				this.$http({
					method: 'get',
					url: 'sys_get_notice_list'
				}).then(res => {
					console.log(res);
					this.notice = res.data
				})
			},
			onRefresh() {
				setTimeout(() => {
					this.$toast(this.$t("reservation.refresh"));
					this.isLoading = false;
					this.getNoticeList();
				}, 500);
			},
		},
		created() {
			this.getNoticeList();
		}
	};
</script>

<style lang='less' scoped>
	.pages-notice {
		min-height: 100vh;
		background-color: #f5f5f5
	}

	/* 导航栏返回按钮 */
	.custom-nav-bar {
		height: 45px;
		position: fixed;
		z-index: 999;
		display: block;
		position: relative;
		line-height: normal;
	}

	::v-deep .van-nav-bar__content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		min-height: 0;
		height: 45px;
		padding-top: 0px;
		background-color: rgb(255, 255, 255);
		z-index: 29090;
		box-shadow: 0px 0px 41px 0px rgba(0, 0, 0, .05);
		position: fixed;
		width: 100%;
		top: 0;
	}

	::v-deep .van-nav-bar__left {
		padding: 0;
	}

	::v-deep .van-nav-bar__title {
		color: #000 !important;
		font-size: 18px;
		font-weight: 700;
		top: 0px;
		height: 45px;
		line-height: 45px;
		width: calc(100% - 100px);
		position: absolute;
		text-align: center;
		left: 0;
		right: 0;
		bottom: 0;
		cursor: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.nav-bar__back {
		width: 31px;
		height: 31px;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		background-color: rgba(0, 0, 0, .05);
		border-radius: 50%;
		color: #333;
		font-size: 14px;
	}

	/* 页面内容 */
	.page-content {
		padding: 20px 10px;
	}

	/* 通知列表 */
	.notice-list {
		background: #fff;
		border-radius: 8px;
		margin: 0 10px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .08);
		overflow: hidden
	}

	/* 通知项 */
	.notice-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 12px;
		border-bottom: 0.5px solid #f0f0f0;
		transition: all .3s ease
	}

	.notice-item:last-child {
		border-bottom: none
	}

	.notice-item:active {
		background-color: #f8f9fa
	}

	.notice-item__content {
		flex: 1;
		margin-right: 8px
	}

	.notice-item__title {
		font-size: 14px;
		color: #333;
		line-height: 1.4;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical
	}

	.notice-item__arrow {
		font-size: 14px
	}

	/* 空状态 */
	.empty-state {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 62px 0
	}

	.empty-state .empty-icon {
		margin-bottom: 12px
	}

	.empty-state .empty-text {
		font-size: 12px;
		color: #999
	}

	/* 底部安全边距 */
	.tn-tabbar-height {
		min-height: 31px;
		height: calc(31px + env(safe-area-inset-bottom) / 2);
		height: calc(31px + constant(safe-area-inset-bottom))
	}
</style>
